import React from 'react';
import { AutocompleteSelect } from '@this/shared/ui/inputs/autocomplete';

export interface ShareholderTicketFeesAirportOption {
  label: string;
  code: string;
}

interface Props {
  getOptions: (inputValue?: string) => Promise<ShareholderTicketFeesAirportOption[]>;
  placeholder: string;
  value: ShareholderTicketFeesAirportOption | null;
  onSelect: (airport: ShareholderTicketFeesAirportOption | null) => void;
}

export const ShareholderTicketFeesAirportSelect: React.FC<Props> = ({
  getOptions,
  placeholder,
  value,
  onSelect
}) => (
  <AutocompleteSelect
    async="FILTERING"
    getOptions={getOptions}
    value={value}
    placeholder={placeholder}
    getOptionLabel={airport => airport.label}
    onChange={(_e, selected) => {
      onSelect(selected);
    }}
  />
);
